import StoredLayout from '../../layouts/StoredLayout'
import TableWidgets from './TableWidgets'
export default StoredLayout(TableWidgets)
